import React, { useEffect, useState } from "react";
import { PublicLayout } from "../components/Layout";
import { useI18n } from "../lib/i18n";
import { api } from "../lib/api";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";

export default function FAQ() {
  const { t, lang } = useI18n();
  const [faq, setFaq] = useState([]);
  useEffect(() => { api.get("/faq").then((r) => setFaq(r.data)).catch(() => {}); }, []);
  return (
    <PublicLayout>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-16">
        <h1 className="font-heading text-3xl sm:text-4xl font-extrabold text-slate-900">{t("faq.title")}</h1>
        <Accordion type="single" collapsible className="mt-8">
          {faq.map((f) => (
            <AccordionItem key={f.id} value={f.id} data-testid={`faq-page-item-${f.id}`}>
              <AccordionTrigger className="text-left font-medium">{lang === "fr" ? f.question_fr : f.question_nl}</AccordionTrigger>
              <AccordionContent className="text-slate-600">{lang === "fr" ? f.answer_fr : f.answer_nl}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </PublicLayout>
  );
}
